export const SOCKET = {
    SOCKET_SERVER_URL: "https://websocketsreverb.com",
    SOCKET_PORT: 8081
}

export const REVERB = {
    REVERB_APP_KEY: '1u6ootetjuqvgl7lardm',
    REVERB_HOST: 'websocketsreverb.com',
    REVERB_PORT: 8081
}

export const API = {
    BASE_URL : 'https://74win.in/',
    API_BASE_URL_SELF : 'https://74win.in/api/',
    API_BASE_URL : 'https://crickfast.com/api/',
}